import React, { useMemo } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link, useMatches } from 'react-router-dom';
import { collectRouteCrumbs } from './routeCrumbs';

const AppBreadcrumbs: React.FC = () => {
  const matches = useMatches();

  const crumbs = useMemo(() => collectRouteCrumbs(matches), [matches]);

  if (crumbs.length === 0) {
    return null;
  }

  return (
    <Breadcrumb className="py-2 mb-0">
      {crumbs.map((c, idx) => {
        const isLast = idx === crumbs.length - 1;
        if (!c.to || isLast) {
          return (
            <Breadcrumb.Item key={`${c.label}-${idx}`} active={isLast}>
              {c.label}
            </Breadcrumb.Item>
          );
        }
        return (
          <Breadcrumb.Item key={`${c.label}-${idx}`} linkAs={Link} linkProps={{ to: c.to }}>
            {c.label}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default AppBreadcrumbs;
